import {
  ArchiveIcon,
  blue,
  neutral,
  MapLargeIcon,
  WarningIcon,
  ProcoreIcon,
  AutodeskIcon,
  WorldMapMarkerIcon,
} from "@flat-ui";
import { ComponentProps } from "react";

/** Archive icon from design system with independent arrow and border colors */
export function ArchiveTwoToneIcon(
  props: ComponentProps<typeof ArchiveIcon>
): JSX.Element {
  return (
    <ArchiveIcon
      {...props}
      sx={{
        ...props.sx,
        "& > g > path:first-of-type": {
          fill: blue[400],
        },
        "& > g > path:last-of-type": {
          fill: neutral[600],
        },
      }}
    />
  );
}

/** Map list icon from design system with independent arrow and border colors */
export function MapListTwoToneIcon(
  props: ComponentProps<typeof MapLargeIcon>
): JSX.Element {
  return (
    <MapLargeIcon
      {...props}
      sx={{
        ...props.sx,
        "& > g > path:nth-of-type(2)": {
          fill: neutral[600],
        },
        "& > g > circle": {
          fill: blue[400],
        },
        "& > g > circle:first-of-type": {
          fill: neutral[600],
        },
      }}
    />
  );
}

/** Warning icon from design system with independent arrow and border colors */
export function WarningTwoToneIcon(
  props: ComponentProps<typeof WarningIcon>
): JSX.Element {
  return (
    <WarningIcon
      {...props}
      sx={{
        ...props.sx,
        "& > g": {
          fill: blue[400],
        },
        "& > path:first-of-type": {
          fill: neutral[600],
        },
        "& > path:last-of-type": {
          fill: "none",
        },
      }}
    />
  );
}

/** Procore icon with white logo area forced to black for light backgrounds. */
export function ProcoreIntegrationIcon(
  props: ComponentProps<typeof ProcoreIcon>
): JSX.Element {
  return (
    <ProcoreIcon
      {...props}
      sx={{
        ...props.sx,
        "& path:first-of-type": {
          fill: neutral[1000],
        },
      }}
    />
  );
}

/** Autodesk icon with white logo area forced to black for light backgrounds. */
export function AutodeskIntegrationIcon(
  props: ComponentProps<typeof AutodeskIcon>
): JSX.Element {
  return (
    <AutodeskIcon
      {...props}
      sx={{
        ...props.sx,
        "& path:first-of-type": {
          fill: neutral[1000],
        },
      }}
    />
  );
}

/** World Map Marker icon with black color for light backgrounds. */
export function WorldMapMarkerIntegrationIcon(
  props: ComponentProps<typeof WorldMapMarkerIcon>
): JSX.Element {
  return (
    <WorldMapMarkerIcon
      {...props}
      sx={{
        ...props.sx,
        color: neutral[1000],
        "& path": { fill: "currentColor" },
      }}
    />
  );
}
